import { IDBPDatabase } from 'idb';

import { openIndexDb, StoreNames } from '../config';

export abstract class BaseManager<T extends Record<string, any>> {
  protected storeName: StoreNames;

  constructor(storeName: StoreNames) {
    this.storeName = storeName;
  }

  protected async getDb(): Promise<IDBPDatabase> {
    return openIndexDb();
  }

  protected abstract generateKey(item: T): string;

  protected serializeItem(item: T): T {
    // Convert to plain object to remove non-serializable properties
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return JSON.parse(JSON.stringify(item));
  }

  async save(item: T): Promise<void> {
    const db = await this.getDb();
    const plainItem = this.serializeItem(item);
    const key = this.generateKey(item);
    await db.put(this.storeName, plainItem, key);
  }

  async get(key: string): Promise<T | undefined> {
    const db = await this.getDb();
    return db.get(this.storeName, key) as Promise<T | undefined>;
  }

  async getAll(): Promise<T[]> {
    const db = await this.getDb();
    return db.getAll(this.storeName) as Promise<T[]>;
  }

  async delete(key: string): Promise<void> {
    const db = await this.getDb();
    await db.delete(this.storeName, key);
  }

  async clear(): Promise<void> {
    const db = await this.getDb();
    await db.clear(this.storeName);
  }
}
